<template>
<div class="ScreenLoadingList">
<div class="container-fluid">
  <div class="table-responsive margin-Top-6Perc overflowXHidden">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Name</th>
          <th class="text-align-center font-size-15px border-right">Image</th>
          <th class="text-align-center font-size-15px border-right">Version</th>
          <th class="text-align-center font-size-15px border-right">Author</th>
          <th class="text-align-center font-size-15px border-right">Quote</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="screenLoadingObj in getScreenLoadingList" :key="screenLoadingObj.LoadingAssetMetaDataId" v-bind:screenLoadingObj="screenLoadingObj" > 
          <td class="border-right text-align-center col-lg-1">{{screenLoadingObj.AssetName}}</td>
          <td class="border-right text-align-center col-lg-3">
            <img class="imgWidthHeight imgCenterCrop" :src="screenLoadingObj.AssetURL">
          </td>
          <!-- <td class="border-right text-align-center col-lg-2">{{formatAndShowDate(screenLoadingObj.CreatedTS)}}</td> -->
          <!-- <td class="border-right text-align-center col-lg-2">{{formatAndShowDate(screenLoadingObj.UpdatedTS)}}</td> -->
          <td class="border-right text-align-center col-lg-1">{{screenLoadingObj.Version}}</td>
          <td class="border-right text-align-center col-lg-2">{{screenLoadingObj.Author}}</td>
          <td class="border-right text-align-center col-lg-3">{{screenLoadingObj.Quote}}</td>
  
          <td class="border-right text-align-center col-lg-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'view', screenLoadingObj)"> View  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'update', screenLoadingObj)"> Edit  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', screenLoadingObj)"> Delete</a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteScreenLoadingString" v-bind:postfixString="postDeleteScreeLoadingString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
  <view-screen-loading-overlay v-if="showViewScreenLoadingOverlay" :selectedScreenLoadingObj="getSelectedLearningLevelObj" @closeOverlay="CloseCurrentOpenScreenLoadingOverlay"></view-screen-loading-overlay>
  <update-screen-loading-overlay v-if="showUpdateScreenLoadingOverlay" :selectedScreenLoadingObj="getSelectedLearningLevelObj" @closeOverlay="CloseCurrentOpenScreenLoadingOverlay"></update-screen-loading-overlay>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import UpdateScreenLoadingOverlay from '@/components/screen_loading/UpdateScreenLoadingOverlay'
import ViewScreenLoadingOverlay from '@/components/screen_loading/ViewScreenLoadingOverlay'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { screenLoadingService } from '@/server-util/screen-loading-services'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import filter from 'lodash/filter'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
// import server from '@/utils/server'

export default {
  props: ['screenLoadingList'],
  data: function () {
    return {
      showViewScreenLoadingOverlay: false,
      showUpdateScreenLoadingOverlay: false,
      selectedScreenLoadingObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      prefixDeleteScreenLoadingString: '',
      postDeleteScreeLoadingString: '',
      showConfirmationBox: false
    }
  },
  name: 'ScreenLoadingList',
  methods: {
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteSelectedScreenLoading()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    CloseCurrentOpenScreenLoadingOverlay (value) {
      const closeOverlay = value.closeOverlay
      const updatedObj = value.updatedObj
      if (updatedObj !== null) {
        const currObjIndex = findIndex(this.getScreenLoadingListFromState, (obj) => {
          return obj.LoadingAssetMetaDataId === updatedObj.LoadingAssetMetaDataId
        })
        if (currObjIndex !== -1) {
          this.getScreenLoadingListFromState[currObjIndex] = updatedObj
        }
        this.$emit('updatedScreenLoadingList', this.screenLoadingList)
      }
      this.showViewScreenLoadingOverlay = !closeOverlay
      this.showUpdateScreenLoadingOverlay = !closeOverlay
      // Enable Background Scrolling
      this.$store.state.isOverlayVisible = !closeOverlay
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    performClickOperation: function (event, selectedOperation, selectedObj) {
      this.selectedScreenLoadingObj = selectedObj
      // console.log(JSON.stringify(this.selectedScreenLoadingObj))
      switch (selectedOperation) {
        case 'view':
          this.showViewScreenLoadingOverlay = true
          // Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'update':
          this.showUpdateScreenLoadingOverlay = true
          // Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteScreenLoadingString = 'Are you sure you want delete '
          this.postDeleteScreeLoadingString = '\'' + this.selectedScreenLoadingObj.AssetName + '\' screen loading?'
          break
      }
    },
    deleteSelectedScreenLoading: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedScreenLoadingObj.LoadingAssetMetaDataId !== undefined &&
        this.selectedScreenLoadingObj.LoadingAssetMetaDataId !== null &&
        this.selectedScreenLoadingObj.LoadingAssetMetaDataId !== 'null'
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        screenLoadingService
          .deleteScreenLoading(
            storeObj.state.access_token,
            this.selectedScreenLoadingObj.LoadingAssetMetaDataId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // Remove selected Learning level object
                this.removeSelectedObjFromList()
                _this.$store.state.isLoading = false
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'LoadingAssetMetaDataId is NULL hence declined DELETE SCREEN LOADING OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    removeSelectedObjFromList: function () {
      var listToReturn = filter(this.getScreenLoadingListFromState, (obj) => {
        return this.selectedScreenLoadingObj.LoadingAssetMetaDataId !== obj.LoadingAssetMetaDataId
      })
      this.$emit('updatedScreenLoadingList', listToReturn)
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'update-screen-loading-overlay': UpdateScreenLoadingOverlay,
    'view-screen-loading-overlay': ViewScreenLoadingOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getScreenLoadingList: {
      get: function () {
        // console.log('Sample satish', this.screenLoadingList)
        return this.screenLoadingList
      }
    },
    getSelectedLearningLevelObj: {
      get: function () {
        return this.selectedScreenLoadingObj
      }
    },
    getScreenLoadingListFromState: {
      get: function () {
        return this.$store.state.screenLoadingList
      },
      set: function (newValue) {
        this.$store.state.screenLoadingList = newValue
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.ScreenLoadingList {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}

a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.overflowXHidden {
  overflow-x: hidden;
}
.imgWidthHeight {
  width: 180px;
  height: 110px;
}
.imgCenterCrop {
  width:150px;
  height:150px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/screen_loading/ScreenLoadingList.vue